module.exports = __webpack_public_path__ + "img/error.772c5f0d.svg";